import React from "react";
import { observer, inject } from "mobx-react";
import { STORE_AUTH } from "../../../../../../constants";
import { Form } from "react-bootstrap";
import { wrapCheckbox } from "../../../../../../common/FormChangeWrapper";
import { AuthStore } from "../../../../../../stores";

interface IProps {
    confirmOrder: boolean;
    sendPaymentLink: boolean;
    changeCheckboxesCallback: (fieldName: string, value: string, checked: boolean) => void;
}

@inject(STORE_AUTH)
@observer
export class ConfirmationStep2Abteka extends React.Component<IProps, {}> {
    constructor(props: any) {
        super(props);
    }

    authStore = (this.props as any)[STORE_AUTH] as AuthStore;


    render() {
        return <Form>
            <Form.Check
                type="checkbox"
                id="confirm_order"
                checked={this.props.confirmOrder}
                name="confirmOrder"
                label="Подтвердить заказ"
                onChange={wrapCheckbox(this.props.changeCheckboxesCallback)}
            />
            <Form.Check
                type="checkbox"
                id="send_payment_link"
                checked={this.props.sendPaymentLink}
                name="sendPayLink"
                label="Отправить ссылку на оплату в смс"
                onChange={wrapCheckbox(this.props.changeCheckboxesCallback)}
            />
        </Form>
    }
}